import axios from 'axios';
import { call, put, takeLatest } from 'redux-saga/effects';
import {
    FETCH_DASHBOARD_STATS_REQUEST,
    fetchDashboardStatsFailure,
    fetchDashboardStatsSuccess,
} from './actions';

function fetchStats() {
  return axios.get('/api/dashboard/stats');
}

function* handleFetchDashboardStats(): Generator {
  try {
    const response: any = yield call(fetchStats);
    yield put(fetchDashboardStatsSuccess(response.data));
  } catch (error: any) {
    const message = error?.response?.data?.error ?? error?.message ?? 'Failed to load dashboard stats';
    yield put(fetchDashboardStatsFailure(message));
  }
}

export function* dashboardSaga() {
  yield takeLatest(FETCH_DASHBOARD_STATS_REQUEST, handleFetchDashboardStats);
}
